<vc-dialog
    [visible]="visible"
    [title]="dialogTitle"
    [primaryLabel]="'COMMON_UI.NEXT' | transloco"
    [secondaryLabel]="'COMMON_UI.CANCEL' | transloco"
    [width]="'430px'"
    [closeOnPrimary]="false"
    [actionsOnLeft]="false"
    (visibleChange)="visibleChange.emit($event)"
    (primaryTrigger)="nextStep()"
    (secondaryTrigger)="cancelled.emit()">
    <div class="body-medium space-pd-top-4">
        <vc-input
            [label]="'ACCOUNT.ENABLE_MFA_VERIFICATION_CODE' | transloco"
            [(value)]="verificationCode"
            [required]="true"></vc-input>
        <span>{{ 'ACCOUNT.DISABLE_MFA_ENTER_CODE' | transloco }}</span>
    </div>
</vc-dialog>
